<template>
  <div class="paper-time"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="header theme-text">
      <span class="trigger" @click="handleCancel"><i class="el-icon-back"></i>返回上级</span>
    </div>
    <template v-if="practiceInfo">
      <div class="cont">
        <AppScrollbar style="height: 100%">
          <div class="main-cont">
            <TitleGroup>
              <template #title>
                <span>论文各阶段时间设置</span><span class="tip-msg">（论文时间：{{practiceInfo.startDate}}-{{practiceInfo.endDate}}）</span>
              </template>
              <div class="config-info">
                <div class="config-form">
                  <el-form size="mini"
                          label-width="120px"
                          label-suffix="：">
                    <el-form-item label="双选报名开始时间" required>
                      <el-date-picker v-model="form.chooseStartDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择双选报名开始时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="双选报名截止时间" required>
                      <el-date-picker v-model="form.chooseEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择双选报名截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="导师确认开始时间" required>
                      <el-date-picker v-model="form.teacherChooseStartDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择导师确认开始时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="导师确认截止时间" required>
                      <el-date-picker v-model="form.teacherChooseEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择导师确认截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="开题报告截止时间">
                      <el-date-picker v-model="form.syllabusEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择开题报告截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="初稿截止时间">
                      <el-date-picker v-model="form.firstEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择初稿截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="预答辩截止时间">
                      <el-date-picker v-model="form.preRejoinEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择预答辩截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="答辩截止时间">
                      <el-date-picker v-model="form.rejoinEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择答辩截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="中期考核截止时间">
                      <el-date-picker v-model="form.midCheckEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择中期考核截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="终稿截止时间">
                      <el-date-picker v-model="form.finalEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择终稿截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="归档截止时间" required>
                      <el-date-picker v-model="form.archivingEndDate"
                                      type="date"
                                      prefix-icon="el-icon-date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="请选择归档截止时间"
                                      :picker-options="{disabledDate: disabledThesisDate}">
                      </el-date-picker>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </TitleGroup>
            <TitleGroup title="参与开题报告">
              <div class="config-info">
                <div class="config-form">
                  <el-form size="mini"
                          label-width="120px"
                          label-suffix="：">
                    <el-form-item label="是否需要开题报告" required>
                      <el-radio-group v-model="form.useSyllabus">
                        <el-radio label="1">需要</el-radio>
                        <el-radio label="0">不需要&nbsp;&nbsp;<span class="tip-msg">注：如选择“不需要”，将跳过开题报告工作至论文定稿</span></el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </TitleGroup>
            <TitleGroup title="模板管理">
              <div class="config-info">
                <div class="config-form">
                  <el-form size="mini"
                          label-width="130px"
                          label-suffix="：">
                    <el-form-item label="预答辩登记表模板" required>
                      <ThesisPracticePopperSampleTemplate :template-file.sync="preRejoinTemplate.sourceUrl"
                                                          :template-preview="preRejoinTemplate.previewUrl"
                                                          type-code="preRejoin"
                                                          :paper-batch-id="rowData.id">
                        <template v-slot:default="{toggleVisible}">
                          <el-button type="text" icon="el-icon-plus" @click="toggleVisible">预答辩登记表模板样例</el-button>
                        </template>
                      </ThesisPracticePopperSampleTemplate>
                      <span class="preview-wrap">
                        <FilePreview :previewUrl="preRejoinTemplate.previewUrl"></FilePreview>
                      </span>
                    </el-form-item>
                    <el-form-item label="毕业论文申请书模板" required>
                      <ThesisPracticePopperSampleTemplate :template-file.sync="applyTemplate.sourceUrl"
                                                          :template-preview="applyTemplate.previewUrl"
                                                          type-code="apply"
                                                          :paper-batch-id="rowData.id">
                        <template v-slot:default="{toggleVisible}">
                          <el-button type="text" icon="el-icon-plus" @click="toggleVisible">毕业论文申请书模板样例</el-button>
                        </template>
                      </ThesisPracticePopperSampleTemplate>
                      <span class="preview-wrap">
                        <FilePreview :previewUrl="applyTemplate.previewUrl"></FilePreview>
                      </span>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </TitleGroup>
            <TitleGroup title="开题报告项自定义">
              <div class="config-info">
                <div class="config-form condensed">
                  <el-form>
                    <el-form-item>
                      <div class="custom-item-wrap">
                        <el-checkbox v-model="form.setupSyllabusDefine"
                                     true-label="1"
                                     false-label="0">
                          <span>启用开题报告表单项自定义</span>
                          <span class="tip-msg">（开启后，学生将根据开题报告项目内容完成开题报告）</span>
                        </el-checkbox>
                        <div class="extra" v-if="form.setupSyllabusDefine === '1'">
                          <ThesisPracticePopperSampleTemplate :template-file.sync="syllabusTemplate.sourceUrl"
                                                              :template-preview="syllabusTemplate.previewUrl"
                                                              type-code="syllabus"
                                                              :paper-batch-id="rowData.id">
                            <template v-slot:default="{toggleVisible}">
                              <el-button class="text-btn" type="text" icon="el-icon-plus" @click="toggleVisible">模板样例</el-button>
                            </template>
                          </ThesisPracticePopperSampleTemplate>
                          <span class="preview-wrap">
                            <FilePreview :previewUrl="syllabusTemplate.previewUrl"></FilePreview>
                          </span>
                          <ThesisPracticePopperPreview :input-subjects="syllabusSetting.inputSubjects">
                            <template v-slot:default="{toggleVisible}">
                              <el-button class="text-btn" type="text" icon="el-icon-view" @click="toggleVisible">预览表单</el-button>
                            </template>
                          </ThesisPracticePopperPreview>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item v-if="form.setupSyllabusDefine === '1'">
                      <div class="syllabus-subject">
                        <DataGrid size="mini"
                                  ref="grid"
                                  border="none"
                                  :key="gridKey"
                                  fit
                                  :data="syllabusSetting.inputSubjects">
                          <DataGridColumn width="70px"
                                          title="勾选配置"
                                          align="center">
                            <template v-slot:default="{row}">
                              <el-checkbox v-model="row.checked" @change="handleChangeChecked($event, row)"></el-checkbox>
                            </template>
                          </DataGridColumn>
                          <DataGridColumn width="88px"
                                          title="表单顺序"
                                          field="ascNum"
                                          align="center">
                            <template v-slot:default="{row}">
                              <el-input-number v-model="row.ascNum"
                                              @change="handleChangeAscNum($event, row)"
                                              :controls="false"
                                              :precision="0"
                                              size="mini"
                                              :min="1"></el-input-number>
                            </template>
                          </DataGridColumn>
                          <DataGridColumn width="120px"
                                          title="表单字段"
                                          align="left"
                                          headerClassName="align-left-cell"
                                          field="fieldName">
                            <template v-slot:default="{row}">
                              <div class="field-name-cell">
                                <el-tooltip class="filed-name"
                                            :content="row.fieldName"
                                            placement="top">
                                  <span>{{row.fieldName}}</span>
                                </el-tooltip>
                                <el-tooltip v-if="row.fieldMemo"
                                            placement="top"
                                            :content="row.fieldMemo">
                                  <i class="el-icon-warning"></i>
                                </el-tooltip>
                              </div>
                            </template>
                          </DataGridColumn>
                          <DataGridColumn width="70px"
                                          title="字段类型"
                                          field="fieldType"
                                          align="center"></DataGridColumn>
                          <DataGridColumn width="200px"
                                          align="left"
                                          headerClassName="align-left-cell"
                                          title="重命名字段名称（少于50字）">
                            <template v-slot:default="{row}">
                              <el-input v-model="row.subject"
                                        size="mini"
                                        type="text"
                                        style="width: 180px"
                                        maxlength="50"></el-input>
                            </template>
                          </DataGridColumn>
                          <DataGridColumn width="150px"
                                          headerClassName="align-left-cell"
                                          title="填写角色"
                                          align="left">
                            <template v-slot:default="{row}">
                              <el-radio-group v-model="row.roleType">
                                <el-radio label="student">学生</el-radio>
                                <el-radio label="teacher">指导教师</el-radio>
                              </el-radio-group>
                            </template>
                          </DataGridColumn>
                        </DataGrid>
                      </div>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </TitleGroup>
          </div>
        </AppScrollbar>
      </div>
      <div class="footer">
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button type="primary"
                   size="mini"
                   :loading="committing"
                   @click="handleSubmit">{{ committing ? '保存中...' : '保存设置' }}</el-button>
      </div>
    </template>
    <Hint v-else v-show="errorMsg" type="error">
      <div>{{ errorMsg }}</div>
      <el-button type="text" @click="loadData">重新加载</el-button>
    </Hint>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../widgets/custom/TitleGroup'
import DataGrid from '../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../elements/DataGridColumn'
import ThesisPracticePopperSampleTemplate from './popper/sample-template'
import ThesisPracticePopperPreview from './popper/preview'
import FilePreview from '../../../../../widgets/custom/FilePreview'
import Hint from '../../../../../elements/Hint'
import moment from 'moment'
export default {
  name: 'PaperTime',
  components: {
    AppScrollbar,
    TitleGroup,
    DataGrid,
    DataGridColumn,
    Hint,
    ThesisPracticePopperPreview,
    ThesisPracticePopperSampleTemplate,
    FilePreview
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      practiceInfo: null,
      form: {
        chooseStartDate: '',
        chooseEndDate: '',
        teacherChooseStartDate: '',
        teacherChooseEndDate: '',
        syllabusEndDate: '',
        firstEndDate: '',
        midCheckEndDate: '',
        finalEndDate: '',
        preRejoinEndDate: '',
        rejoinEndDate: '',
        useSyllabus: '',
        archivingEndDate: '',
        setupSyllabusDefine: ''
      },
      syllabusSetting: {},
      syllabusTemplate: {},
      preRejoinTemplate: {},
      applyTemplate: {},
      gridKey: 1
    }
  },
  computed: {
    thesisStartDate () {
      let practiceInfo = this.practiceInfo
      if (practiceInfo && practiceInfo.startDate) {
        return moment(practiceInfo.startDate, 'YYYY-MM-DD').toDate()
      }
    },
    thesisEndDate () {
      let practiceInfo = this.practiceInfo
      if (practiceInfo && practiceInfo.endDate) {
        return moment(practiceInfo.endDate, 'YYYY-MM-DD').toDate()
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('hidePopover')
    },
    handleChangeChecked (val, row) {
      if (!val) {
        this.$set(row, 'ascNum', undefined)
        this.$set(row, 'subject', '')
        this.$set(row, 'roleType', '')
      }
    },
    handleChangeAscNum (val, row) {
      if (val) {
        const inputSubjects = this.syllabusSetting.inputSubjects
        const sameAscNumSubjects = inputSubjects.filter(subject => subject.ascNum === val)
        if (sameAscNumSubjects && sameAscNumSubjects.length > 1) {
          this.$message.warning('表单顺序不能重复')
          row.ascNum = undefined
          this.gridKey = Date.now()
        }
      }
    },
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/batch/practiceInfo',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.rowData.id
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.practiceInfo = response.data.practiceInfo
        } else {
          this.errorMsg = response.data.message || '获取论文数据失败'
        }
      }, () => {
        this.errorMsg = '获取论文数据失败'
      }).finally(() => {
        this.loading = false
      })
    },
    disabledThesisDate (date) {
      let thesisStartDate = this.thesisStartDate
      if (thesisStartDate && date.getTime() < thesisStartDate.getTime()) {
        return true
      }
      let thesisEndDate = this.thesisEndDate
      if (thesisEndDate && date.getTime() > thesisEndDate.getTime()) {
        return true
      }
    },
    handleSubmit () {
      const form = this.form
      if (!form.chooseStartDate) {
        this.$message.warning('请选择双选报名开始时间')
        return
      }
      if (!form.chooseEndDate) {
        this.$message.warning('请选择双选报名截止时间')
        return
      }
      if (!form.teacherChooseStartDate) {
        this.$message.warning('请选择导师确认开始时间')
        return
      }
      if (!form.teacherChooseEndDate) {
        this.$message.warning('请选择导师确认截止时间')
        return
      }
      if (!form.archivingEndDate) {
        this.$message.warning('请选择归档截止时间')
        return
      }
      if (!form.useSyllabus) {
        this.$message.warning('请选择是否需要开题报告')
        return
      }
      let syllabusSetting = JSON.parse(JSON.stringify(this.syllabusSetting))
      if (form.setupSyllabusDefine === '1') {
        if (syllabusSetting.inputSubjects) {
          syllabusSetting.inputSubjects = syllabusSetting.inputSubjects.filter(item => item.checked)
          if (syllabusSetting.inputSubjects.length) {
            // 表单顺序和角色必填
            for (let i = 0; i < syllabusSetting.inputSubjects.length; i++) {
              const item = syllabusSetting.inputSubjects[i]
              if (!item.ascNum) {
                this.$message.warning('请完善开题报告表单项：表单顺序')
                return
              }
              if (!item.roleType) {
                this.$message.warning('请完善开题报告表单项：填写角色')
                return
              }
            }
          } else {
            this.$message.warning('请至少填写一行开题报告表单项')
            return
          }
        }
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/paper/batch/submitPracticeInfo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          paperBatchId: this.rowData.id,
          practiceInfo: JSON.stringify({
            inputSubjects: syllabusSetting.inputSubjects
          })
        }, form))
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success(response.data.message || '保存成功')
          this.$nextTick(() => {
            this.$emit('hidePopoverAndRefresh')
          })
        } else {
          this.$message.error(response.data.message || '保存失败')
        }
      }, () => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        }
      },
      immediate: true
    },
    practiceInfo: function (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (key in val) {
            this.form[key] = val[key]
          }
        })
        this.syllabusSetting = val.syllabusSetting || {}
        this.syllabusTemplate = val.syllabusTemplate || {}
        this.preRejoinTemplate = val.preRejoinTemplate || {}
        this.applyTemplate = val.applyTemplate || {}
        if (this.syllabusSetting.inputSubjects) {
          this.syllabusSetting.inputSubjects.forEach(item => {
            if (!item.hasOwnProperty('ascNum')) {
              this.$set(item, 'ascNum', undefined)
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.paper-time {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  & > .header {
    flex: none;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    & > .trigger{
      cursor: pointer;
      .el-icon-back{
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }
  & > .cont{
    flex: 1;
    height: 0;
    .main-cont {
      margin: auto;
      width: 700px;
      max-width: 100%;
      .title-group {
        margin-top: 20px;
        border-bottom: 1px solid #ebeef5;
        &:last-child {
          border-bottom: none;
        }
        & > .header {
          .tip-msg {
            color: #909399;
            font-size: 12px;
            font-weight: normal;
          }
        }
        & > .main {
          padding-top: 20px;
          .config-info {
            & > .config-form {
              &.condensed {
                .el-form {
                  .el-form-item {
                    margin-bottom: 20px;
                    .el-form-item__label {
                      line-height: 1;
                    }
                    .el-form-item__content {
                      line-height: 1;
                    }
                  }
                }
              }
              .el-form {
                .el-form-item {
                  .el-form-item__label {
                    font-size: 12px;
                    text-align: left;
                    white-space: nowrap;
                  }
                  .el-form-item__content {
                    font-size: 12px;
                    .preview-wrap{
                      margin-left: 10px;
                    }
                    .el-checkbox {
                      & > .el-checkbox__label {
                        font-size: 12px;
                      }
                    }
                    .el-radio {
                      & > .el-radio__label {
                        font-size: 12px;
                      }
                    }
                    .el-date-editor {
                      width: 100%;
                    }
                    .el-input-number{
                      width: 50px;
                      .el-input__inner{
                        padding: 0 10px;
                      }
                    }
                    .align-left-cell{
                      & > .vxe-cell{
                        padding-left: 0;
                      }
                    }
                    .el-radio-group{
                      & > .el-radio{
                        margin-right: 15px;
                      }
                    }
                    i{
                      &.el-icon-warning{
                        font-size: 14px;
                        width: 14px;
                        margin-left: 3px;
                      }
                    }
                    .custom-item-wrap{
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      & > .extra{
                        display: flex;
                        align-items: self-end;
                        gap: 15px;
                        & > div{
                          & + div{
                            margin-left: 15px;
                          }
                          .text-btn{
                            padding: 0;
                            border: none;
                          }
                        }
                        .preview-wrap{
                          margin-left: -8px;
                        }
                      }
                    }
                    .field-name-cell{
                      display: flex;
                      align-items: stretch;
                      & > .filed-name{
                        display: inline-block;
                        max-width: 90%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      }
                    }
                    .promise-upload {
                      margin-top: 20px;
                      .file-uploader-wrap {
                        .file-uploader {
                          .el-upload {
                            .el-upload-dragger {
                              text-align: left;
                              .el-button {
                                width: auto!important;
                                padding: 9px 20px 9px 25px;
                                i {
                                  margin-left: -10px;
                                }
                              }
                              .tip {
                                margin-left: 5px;
                                color: #909399;
                              }
                            }
                          }
                        }
                        .file-upload-list {
                          margin-top: 8px;
                          .file-item {
                            & > .file-label {
                              justify-content: flex-start!important;
                            }
                          }
                        }
                      }
                    }
                    .syllabus-subject {
                      border: 1px solid #f3f4f5;
                      .vxe-table {
                        .vxe-table--header-wrapper {
                          margin-bottom: 5px;
                          .vxe-table--header {
                            .vxe-header--row {
                              background-color: #f3f4f5;
                            }
                          }
                        }
                        .vxe-table--body-wrapper {
                          .vxe-table--body {
                            .vxe-body--row {
                              .vxe-body--column {
                                .vxe-cell {
                                  padding-left: 0;
                                  padding-right: 0;
                                }
                              }
                            }
                          }
                        }
                      }
                      & > .footer {
                        padding: 0 15px 5px;
                        text-align: center;
                      }
                    }
                    .tip-text {
                      margin-bottom: 10px;
                      font-size: 12px;
                    }
                    .tip-msg {
                      color: #909399;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  & > .footer{
    text-align: center;
    padding: 10px 0;
  }
}
</style>
